import i18n from '../locales/i18n'

export default function (date, type = "chat", format = {day: "numeric",month: "long"}) {

  try {

    const currentLocale = i18n.locale;

    if (!isNaN(date)) {
      date = new Date(+date).toISOString()
    }

    const today = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).getTime();
    const yesterday = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 1).getTime();
    const tomorrow = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1).getTime();

    const dateFromComment = new Date(
      new Date(date).getFullYear(),
      new Date(date).getMonth(),
      new Date(date).getDate()
    ).getTime();

    if (dateFromComment === today) return "Today";
    if (dateFromComment === yesterday) return "Yesterday";
    if (dateFromComment === tomorrow) return "Tomorrow";

    if (type == "chat")
      if (new Date().getFullYear() == new Date(date).getFullYear()){
        return new Intl.DateTimeFormat(currentLocale, format).format(new Date(date))
      } else {
        return new Intl.DateTimeFormat(currentLocale, {...format, year: "numeric"}).format(new Date(date))
      }
    else if (type == "history")
      return new Intl.DateTimeFormat(currentLocale, {
        year: "2-digit",
        month: "2-digit",
        day: "2-digit",
      }).format(new Date(date));
  } catch (error) {
    
  }
    // return new Date(date).getDate() + '/' + new Date(date).getMonth() + '/' + new Date(date).getFullYear()
}
